import roundValue from './roundValue'

import {
  cellErrorCheck, REVIT_RULES, AUTOCAD_RULES
} from './cellErrorCheck'

const drop_line_debug = false;


// const convertLineToRow_bail = (gx, gy, line_x1, line_y1, line_x2, line_y2, format, type, units, autofix) => {
//   console.log('convert', gx, gy, line_x1, line_y1, line_x2, line_y2, format, type, units, autofix);

//   let dash_space_limit;
//   if(format === 'REVIT'){
//     dash_space_limit = REVIT_RULES[type][units].MAX;
//   } else {
//     dash_space_limit = AUTOCAD_RULES.MAX;
//   }

//   let factor = .001;
//   let numberOfDecimals = 3;

//   let lx1 = simplify(line_x1, factor, numberOfDecimals);
//   let ly1 = simplify(line_y1, factor, numberOfDecimals);
//   let lx2 = simplify(line_x2, factor, numberOfDecimals);
//   let ly2 = simplify(line_y2, factor, numberOfDecimals);

//   let grid_angle = Math.atan2(gy,gx);

//   // here's the hard math:
//   let x_dif = (lx2 - lx1);
//   let y_dif = (ly2 - ly1);

//   // console.log('difs',x_dif, y_dif, gx, gy);
//   let offset = find_grid_offset(x_dif, y_dif, gx, gy);
//   // console.log('off',offset);

//   let gox = offset.x;
//   let goy = offset.y;

//   let space = (Math.sqrt( Math.pow(gox * gx, 2) + Math.pow(goy * gy, 2)) - Math.sqrt( Math.pow(lx2 - lx1, 2) + Math.pow(ly2 - ly1, 2)));
//   let dash = Math.sqrt( Math.pow(lx2 - lx1, 2) + Math.pow(ly2 - ly1, 2));
  
//   console.log('space', space, 'dash', dash);
//   // let e = cellErrorCheck(space + dash, format, type, units, !autofix);

//   // if(e){
//     // console.log('space before', e);

//     let line_angle = Math.atan2(ly2 - ly1, lx2 - lx1);

//     let max_x = Math.cos(line_angle) * (dash_space_limit - Math.abs(lx2 - lx1));
//     let max_y = Math.sin(line_angle) * (dash_space_limit - Math.abs(ly2 - ly1));

//     console.log('max', max_x, max_y);

//     let rounded_x = Math.floor((max_x) / gx) * gx;
//     let rounded_y = Math.floor((max_y) / gy) * gy;


//     console.log('rounded', rounded_x, rounded_y);

//     gox = rounded_x / gx;
//     goy = rounded_y / gy;


//     let reduced = reduce(gox,goy);
//     gox = reduced[0];
//     goy = reduced[1];

//     console.log('after r ', gox,goy, reduced, offset);

//     if(Math.abs(offset.x) < Math.abs(gox) && Math.abs(offset.y) < Math.abs(goy)){
//       gox = offset.x;
//       goy = offset.y;
//     }


//     console.log('before angle', line_angle);
//     line_angle = Math.atan2(goy,gox);

//     console.log('after angle', line_angle);

//     console.log('old L', lx2, ly2);

//     lx2 = dash * Math.cos(line_angle) + lx1;
//     ly2 = dash * Math.sin(line_angle) + ly1;

//     console.log('new L', lx2, ly2);


//     // lx2 = simplify(lx2, factor, numberOfDecimals);
//     // ly2 = simplify(ly2, factor, numberOfDecimals);

//     console.log('new L', lx2, ly2);
    

//     space = (Math.sqrt( Math.pow(gox * gx, 2) + Math.pow(goy * gy, 2)) - Math.sqrt( Math.pow(lx2 - lx1, 2) + Math.pow(ly2 - ly1, 2)));
//     dash = Math.sqrt( Math.pow(lx2 - lx1, 2) + Math.pow(ly2 - ly1, 2));
//     console.log('fixed', 'space', space, 'dash', dash);
//   // }

//   let row = generateRow(gox, goy, gx, gy, lx1, ly1, lx2, ly2, space, format, type, units, autofix);

//   if(row){
//     // row.precision = precision;
//     // row.precisionIndex = precisionIndex;
//     row.originalData = {
//       x1: line_x1,
//       y1: line_y1,
//       x2: line_x2,
//       y2: line_y2,
//     }
//     row.roundedData = {
//       precisionIndex: 0,
//       x1: lx1,
//       y1: ly1,
//       x2: lx2,
//       y2: ly2,
//     }
//   }

//   return row;
// }

// const generateRow_bail = (gox, goy, gx, gy, lx1, ly1, lx2, ly2, space, format, type, units, autofix) => {
//   console.log('generateRow', gox, goy, gx, gy, lx1, ly1, lx2, ly2, space, format, type, units, autofix);
  
//   let lineSlope = (ly2 - ly1) / (lx2 - lx1);
//   let angle = Math.atan(lineSlope);

//   console.log(angle, lineSlope, ly2, ly1, lx2, ly1);

//   if(ly2 <= ly1 && lx1 > lx2){
//     angle += Math.PI;
//   }

//   if(ly2 > ly1 && lx1 > lx2){
//     angle += Math.PI;
//   }

//   if(angle < 0){
//     angle += Math.PI * 2;
//   }
//   if(angle >= Math.PI * 2){
//     angle -= Math.PI * 2;
//   }

//   if(angle == Math.PI && space == 0){
//     angle = 0;
//   }

//   var offset = 0;
//   var shift = 0;

//   var theta = Math.sqrt(gx * gx + gy * gy);
//   // console.log('GO', gox, goy);

//   if(goy == 1){
//     // console.log('y === 1', gx, gy, gox, goy);
//     offset = gx * Math.cos(angle + Math.PI / 2);
//     shift = gx * Math.sin(angle + Math.PI / 2);

//     var e = cellErrorCheck(Math.abs(offset), format, type, units, !autofix);
//     if(drop_line_debug && e) console.log('offset', e);
//     if(e) return;

//     return finalize(gx, gy, lx1, ly1, lx2, ly2, angle, shift, offset, space, 3);
//   } else if(gox == 1){
//     // console.log('x === 1');
//     offset = gy * Math.cos(angle);
//     shift = gy * Math.sin(angle);

//     var e = cellErrorCheck(Math.abs(offset), format, type, units, !autofix);
//     if(drop_line_debug && e) console.log('offset', e);
//     if(e) return;

//     return finalize(gx, gy, lx1, ly1, lx2, ly2, angle, shift, offset, space, 4);
//   } else if(goy == -1){
//     // console.log('y === -1');
//     offset = gx * Math.cos(angle + Math.PI / 2);
//     shift = gx * Math.sin(angle + Math.PI / 2);

//     var e = cellErrorCheck(Math.abs(offset), format, type, units, !autofix);
//     if(drop_line_debug && e) console.log('offset', e);
//     if(e) return;

//     return finalize(gx, gy, lx1, ly1, lx2, ly2, angle, shift, offset, space, 5);
//   } else if(gox == -1){
//     // console.log('x === -1');
//     offset = -gy * Math.cos(angle);
//     shift = gy * Math.sin(angle);

//     var e = cellErrorCheck(Math.abs(offset), format, type, units, !autofix);
//     if(drop_line_debug && e) console.log('offset', e);
//     if(e) return;

//     return finalize(gx, gy, lx1, ly1, lx2, ly2, angle, shift, offset, space, 6);
//   } else {

//     var lowest_offset = Number.MAX_VALUE;
//     var lowest_shift = 0;
//     var lowest_gox = gox;
//     var lowest_goy = goy;

//     var draw_only_lowest = true;

//     // console.log(gx, gy, gox, goy);

//     for(var x = 1; x < Math.abs(gox); x++){
//       for(var y = 1; y < Math.abs(goy); y++){

//         var tx = x;
//         var ty = y;

//         if(gox < 0) tx  *= -1;
//         if(goy < 0) ty  *= -1;

//         var theta = Math.sqrt(tx * tx * gx * gx + ty * ty * gy * gy);
//         var adjustedAngle = angle + (Math.PI/2 - Math.atan2(ty * gy, tx * gx));
//         offset = theta * Math.cos(adjustedAngle);

//         shift = theta * Math.sin(adjustedAngle);

        
//         if(autofix){
//           let e = cellErrorCheck(Math.abs(offset), format, type, units, !autofix);
//           if(drop_line_debug && e) console.log('offset', e);
//           if(e) continue;
//         }
        

//         if(draw_only_lowest === false){
//           return finalize(gx, gy, lx1, ly1, lx2, ly2, angle, shift, offset, space, 1);
//         } else if(Math.abs(offset) < Math.abs(lowest_offset) && roundValue(offset, 8) !== 0){
//           lowest_offset = offset;
//           lowest_shift = shift;
//           lowest_gox = tx;
//           lowest_goy = ty;
//           // console.log('set_lowest', lowest_offset);
//         }
//       }
//     }

//     if(draw_only_lowest){
//       return finalize(gx, gy, lx1, ly1, lx2, ly2, angle, lowest_shift, lowest_offset, space, 2);
//     }
    
//     // console.log('final', temp_gox, temp_goy);
//   }
// }

// const finalize_bail = (gx, gy, lx1, ly1, lx2, ly2, angle, shift, offset, space, where) => {
//   let lineSlope = (ly2 - ly1) / (lx2 - lx1);
//   console.log('finalize', angle, shift, offset, where);
//   if(lineSlope === Infinity || lineSlope === -Infinity){
//     offset = gx;
//   }
//   var cells = [
//     // angle
//     roundValue(angle / Math.PI / 2 * 360,8),

//     // x
//     roundValue(lx1,8),

//     //y 
//     roundValue(ly1,8),

//     // shift,
//     roundValue(shift, 8),

//     // offset
//     roundValue(offset, 8)
//   ];

//   // if its just a dot
//   if(lx1 === lx2 && ly1 === ly2){
//     cells.push(0);        
//     cells.push(-space);
//   } else if(space > 0){
//     cells.push(roundValue(Math.sqrt( Math.pow(lx2 - lx1, 2) + Math.pow(ly2 - ly1, 2)),8));
//     cells.push(-space);
//   }

//   return { cells: cells }
// }

const convertLineToRow = (gx, gy, line_x1, line_y1, line_x2, line_y2, format, type, units, autofix) => {

  var max_spacing = 800;

  var angle = Math.atan2(gy,gx);
  var threshold_x = (800 * gx) / Math.cos(angle);
  var threshold_y = (800 * gy) / Math.sin(angle);
  if(drop_line_debug) console.log('angle', angle, gx,gy, threshold_x, threshold_y);

  var precisionList = [1,10,20,50,100,500,1000];
  var precisionIndex = precisionList.length - 1;
  var numberOfDecimals = 5;

  var decimal_precision = [1, .5, .1, .05, .01, .005, .001, .0005, .0001];
  var precisionIndex = decimal_precision.length - 1;

  var row;
  while(row === undefined){

    // var precision = precisionList[precisionIndex];
    // console.log(precisionIndex);

    // var xfactor = gx / precision;
    // var yfactor = gy / precision;

    var factor = decimal_precision[precisionIndex];
    if(drop_line_debug) console.log(factor);
    // round it to the nearest factor
    if(drop_line_debug) console.log('before', line_x1, line_y1, line_x2, line_y2);
    var lx1 = simplify(line_x1, factor, numberOfDecimals);
    var ly1 = simplify(line_y1, factor, numberOfDecimals);
    var lx2 = simplify(line_x2, factor, numberOfDecimals);
    var ly2 = simplify(line_y2, factor, numberOfDecimals);
    if(drop_line_debug) console.log('after', lx1, ly1, lx2, ly2);

    row = tryToConvertLineToRow(gx, gy, lx1, ly1, lx2, ly2, threshold_x, threshold_y, format, type, units, autofix);

    if(row){
      // row.precision = precision;
      // row.precisionIndex = precisionIndex;
      row.originalData = {
        x1: line_x1,
        y1: line_y1,
        x2: line_x2,
        y2: line_y2,
      }
      row.roundedData = {
        precisionIndex: precisionIndex,
        x1: lx1,
        y1: ly1,
        x2: lx2,
        y2: ly2,
      }
      break;
    }

    precisionIndex--;
    if(precisionIndex < 0){
      return;
    }
  }

  // console.log(row);
  return row;
}



const tryToConvertLineToRow = (gx, gy, lx1, ly1, lx2, ly2, threshold_x, threshold_y, format, type, units, autofix) => {  

  // calculate slopes
  var gridSlope = gy/gx;
  var lineSlope = (ly2 - ly1) / (lx2 - lx1);


  if(Math.abs(lineSlope) === Math.abs(gridSlope)){
    // slope is identical
    gox = 1;
    goy = 1;
  } else if(lineSlope === Infinity || lineSlope === -Infinity){
    // straight up
    gox = 0;
    goy = 1;
  } else if(lx1 === lx2 && ly1 === ly2){
    // also straight up
    // console.log('is this a dot?');
    gox = 1;
    goy = 0;
    lineSlope = 0;
  } else { 

    // here's the hard math:
    var x_dif = (lx2 - lx1);
    var y_dif = (ly2 - ly1);

    // console.log('difs',x_dif, y_dif, gx, gy);
    var offset = find_grid_offset(x_dif, y_dif, gx, gy);
    // console.log('off',offset);

    var gox = offset.x;
    var goy = offset.y;

    // can't remember if this is necessary
    if(isNaN(gox)){
      gox = 1;
    }

    if(Math.abs(gox) > threshold_x || Math.abs(goy) > threshold_y){
      if(drop_line_debug) console.log('Bailing too complex', gox, goy, threshold_x, threshold_y);

      // if the line is too far away, then let's bail and round it further
      return;
    }
  }

  // console.log(lx1, ly1, lx2, ly2, gx, gy, gox, goy);


  var space = (Math.sqrt( Math.pow(gox * gx, 2) + Math.pow(goy * gy, 2)) - Math.sqrt( Math.pow(lx2 - lx1, 2) + Math.pow(ly2 - ly1, 2)));
  // console.log("space is", space, Math.sqrt( Math.pow(gox * gx, 2) + Math.pow(goy * gy, 2)), Math.sqrt( Math.pow(lx2 - lx1, 2) + Math.pow(ly2 - ly1, 2)));

  if(space !== 0){
    var e = cellErrorCheck(space, format, type, units, !autofix);
    if(drop_line_debug && e) console.log('space issue', e,  space, format, type, units);
    // if(e) return;
  }


  if(lineSlope === 0){
    space = gx - Math.abs(lx2 - lx1);
  } else if(lineSlope === Infinity || lineSlope === -Infinity){
    space = gy - Math.abs(ly2 - ly1);
  }

  var angle = Math.atan(lineSlope);

  if(ly2 <= ly1 && lx1 > lx2){
    angle += Math.PI;
  }

  if(ly2 > ly1 && lx1 > lx2){
    angle += Math.PI;
  }

  if(angle < 0){
    angle += Math.PI * 2;
  }
  if(angle >= Math.PI * 2){
    angle -= Math.PI * 2;
  }

  if(angle == Math.PI && space == 0){
    angle = 0;
  }


  function finalize(angle, shift, offset, where){
    // console.log('finalize', angle, shift, offset, where);
    if(lineSlope === Infinity || lineSlope === -Infinity){
      offset = gx;
    }
    var cells = [
      // angle
      roundValue(angle / Math.PI / 2 * 360,8),

      // x
      roundValue(lx1,8),

      //y 
      roundValue(ly1,8),

      // shift,
      roundValue(shift, 8),

      // offset
      roundValue(offset, 8)
    ];

    // if its just a dot
    if(lx1 === lx2 && ly1 === ly2){
      cells.push(0);        
      cells.push(-space);
    } else if(space > 0){
      cells.push(roundValue(Math.sqrt( Math.pow(lx2 - lx1, 2) + Math.pow(ly2 - ly1, 2)),8));
      cells.push(-space);
    }

    return { cells: cells }
  }

  var offset = 0;
  var shift = 0;

  var theta = Math.sqrt(gx * gx + gy * gy);
  // console.log('GO', gox, goy);

  if(goy == 1){
    // console.log('y === 1', gx, gy, gox, goy);
    offset = gx * Math.cos(angle + Math.PI / 2);
    shift = gx * Math.sin(angle + Math.PI / 2);

    var e = cellErrorCheck(Math.abs(offset), format, type, units, !autofix);
    if(drop_line_debug && e) console.log('offset', e);
    if(e) return;

    return finalize(angle, shift, offset, 3);
  } else if(gox == 1){
    // console.log('x === 1');
    offset = gy * Math.cos(angle);
    shift = gy * Math.sin(angle);

    var e = cellErrorCheck(Math.abs(offset), format, type, units, !autofix);
    if(drop_line_debug && e) console.log('offset', e);
    if(e) return;

    return finalize(angle, shift, offset, 4);
  } else if(goy == -1){
    // console.log('y === -1');
    offset = gx * Math.cos(angle + Math.PI / 2);
    shift = gx * Math.sin(angle + Math.PI / 2);

    var e = cellErrorCheck(Math.abs(offset), format, type, units, !autofix);
    if(drop_line_debug && e) console.log('offset', e);
    if(e) return;

    return finalize(angle, shift, offset, 5);
  } else if(gox == -1){
    // console.log('x === -1');
    offset = -gy * Math.cos(angle);
    shift = gy * Math.sin(angle);

    var e = cellErrorCheck(Math.abs(offset), format, type, units, !autofix);
    if(drop_line_debug && e) console.log('offset', e);
    if(e) return;

    return finalize(angle, shift, offset, 6);
  } else {
    

    var lowest_offset = Number.MAX_VALUE;
    var lowest_shift = 0;
    var lowest_gox = gox;
    var lowest_goy = goy;

    var draw_only_lowest = true;

    // console.log(gx, gy, gox, goy);

    for(var x = 1; x < Math.abs(gox); x++){
      for(var y = 1; y < Math.abs(goy); y++){

        var tx = x;
        var ty = y;

        if(gox < 0) tx  *= -1;
        if(goy < 0) ty  *= -1;

        var theta = Math.sqrt(tx * tx * gx * gx + ty * ty * gy * gy);
        var adjustedAngle = angle + (Math.PI/2 - Math.atan2(ty * gy, tx * gx));
        offset = theta * Math.cos(adjustedAngle);
        shift = theta * Math.sin(adjustedAngle);

        
        var e = cellErrorCheck(Math.abs(offset), format, type, units, !autofix);
        if(drop_line_debug && e) console.log('offset', e);
        if(e) return;
        

        if(draw_only_lowest === false){
          return finalize(angle, shift, offset, 1);
        } else if(Math.abs(offset) < Math.abs(lowest_offset) && roundValue(offset, 8) !== 0){
          lowest_offset = offset;
          lowest_shift = shift;
          lowest_gox = tx;
          lowest_goy = ty;
          // console.log('set_lowest', lowest_offset);
        }
      }
    }

    if(draw_only_lowest){
      return finalize(angle, lowest_shift, lowest_offset, 2);
    }
    
    // console.log('final', temp_gox, temp_goy);
  }
}


function countDecimals (n) {
  // console.log(n);
  if(isNaN(n)) return 0;
  if(n.valueOf() === 0)return 0;
  if(Math.floor(n.valueOf()) === n.valueOf()) return 0;
  return n.toString().split(".")[1].length || 0; 
}

function find_grid_offset(lx, ly, gx, gy){
  // console.log('find_grid_offset', lx,ly,gx,gy);
  lx = roundValue(lx, 5);
  ly = roundValue(ly, 5);
  gx = roundValue(gx, 5);
  gy = roundValue(gy, 5);

  // console.log('find_grid_offset', lx,ly,gx,gy);

  var max_decimals = 0;

  if(countDecimals(lx) > max_decimals) max_decimals = countDecimals(lx);
  if(countDecimals(ly) > max_decimals) max_decimals = countDecimals(ly);
  if(countDecimals(gx) > max_decimals) max_decimals = countDecimals(gx);
  if(countDecimals(gy) > max_decimals) max_decimals = countDecimals(gy);

  var decimalFixFactor = Math.pow(10, max_decimals);

  lx *= decimalFixFactor;
  ly *= decimalFixFactor;
  gx *= decimalFixFactor;
  gy *= decimalFixFactor;

  var lcm = lcm_two_numbers(gx, lx);

  var t_ly = ly * (lcm/lx);
  var t_gy = gy * (lcm/gx);


  // console.log('before', t_gy, t_ly);
  var fraction = reduce(t_gy, t_ly);

  // console.log('X:', fraction[0], ' Y:', fraction[1]);
  return {
    x: fraction[0],
    y: fraction[1]
  }
}

function lcm_two_numbers(x, y) {
  if ((typeof x !== 'number') || (typeof y !== 'number')) 
    return false;
  return (!x || !y) ? 0 : Math.abs((x * y) / gcd_two_numbers(x, y));
}

function gcd_two_numbers(x, y) {
  x = Math.abs(x);
  y = Math.abs(y);
  while(y) {
    var t = y;
    y = x % y;
    x = t;
  }
  return x;
}

var reduce = function(numerator,denominator){
  var gcd = function gcd(a,b){
    return b ? gcd(b, a%b) : a;
  };
  gcd = gcd(numerator,denominator);

  if(gcd < 0) gcd *= -1;

  return [numerator/gcd, denominator/gcd];
}


const simplify = (n, factor, numberOfDecimals) => {
  // console.log(n, factor, numberOfDecimals);
  var step_1n = Math.round(n / factor, 0) * factor;
  var step_2n = roundValue(step_1n, numberOfDecimals);
  // console.log('n', n, step_1n, step_2n, factor, numberOfDecimals);
  return roundValue(step_2n, numberOfDecimals);
}


export default convertLineToRow;


// WEBPACK FOOTER //
// ./src/pattern_utilities/convertLineToRow.js